import { mediumColors } from "shared/helpers/colors";
import { MentionType, SocialMentionType } from "shared/types/mentions";

import { type SocialMedium, MediumField, SocialPlatform } from "./types";

// eslint-disable-next-line import/prefer-default-export
export const socialMedia: SocialMedium = {
  medium: "Social",
  label: "Social",
  field: MediumField.SOCIAL,
  icon: `${import.meta.env.VITE_ASSETS_URL}/icons/social.svg`,
  color: mediumColors.social,
  relatedFields: [
    MentionType.tweet,
    MentionType.facebook_post,
    MentionType.youtube_video,
    MentionType.instagram_post,
    MentionType.instagram_comment,
    MentionType.reddit_post,
    MentionType.reddit_post_comment,
    MentionType.blog_post,
    MentionType.forum_post,
    MentionType.bluesky_post,
  ],
  relatedLabels: [
    "Tweet",
    "FacebookPost",
    "YoutubeVideo",
    "InstagramPost",
    "InstagramComment",
    "RedditPost",
    "RedditPostComment",
    "BlogPost",
    "ForumPost",
    "BlueskyPost",
  ],
  platforms: [
    {
      label: "X | Twitter",
      platform: SocialPlatform.TWITTER,
      color: "#77BDF1",
      fields: [SocialMentionType.tweet],
      featureFlag: "view_tweet",
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/twitter.svg`,
      checked: true,
      widgets: ["key_twitter_influencers", "top_tweets"],
    },
    {
      label: "Facebook",
      platform: SocialPlatform.FACEBOOK,
      color: "#61749D",
      fields: [SocialMentionType.facebook_post],
      featureFlag: "view_facebook_post",
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/facebook.svg`,
      checked: true,
      widgets: ["top_facebook_pages", "top_facebook_posts"],
    },
    {
      label: "Instagram",
      platform: SocialPlatform.INSTAGRAM,
      color: "#E3787C",
      fields: [
        SocialMentionType.instagram_post,
        SocialMentionType.instagram_comment,
      ],
      featureFlag: "view_instagram_post",
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/instagram.svg`,
      checked: true,
      widgets: ["key_instagram_influencers"],
    },
    {
      label: "YouTube",
      platform: SocialPlatform.YOUTUBE,
      color: "#D54B3F",
      fields: [SocialMentionType.youtube_video],
      featureFlag: "view_youtube_video",
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/youtube.svg`,
      checked: true,
    },
    {
      label: "Reddit",
      platform: SocialPlatform.REDDIT,
      color: "#FB7A4A",
      fields: [
        SocialMentionType.reddit_post,
        SocialMentionType.reddit_post_comment,
      ],
      featureFlag: "view_reddit_post",
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/reddit.svg`,
      checked: true,
    },
    {
      label: "Blogs",
      platform: SocialPlatform.BLOG,
      color: "#F06A35",
      fields: [SocialMentionType.blog_post],
      featureFlag: "view_blog_post",
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/blog.svg`,
      checked: true,
    },
    {
      label: "Forums",
      platform: SocialPlatform.FORUM,
      color: "#FFB649",
      fields: [SocialMentionType.forum_post],
      featureFlag: "view_forum_post",
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/forum.svg`,
      checked: true,
    },
    {
      label: "Bluesky",
      platform: SocialPlatform.BLUESKY,
      color: "#1285FE",
      fields: [SocialMentionType.bluesky_post],
      featureFlag: "view_bluesky_post",
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/bluesky.svg`,
      checked: true,
    },
  ],
  relatedTypes: [
    {
      label: "Tweet",
      appLabel: "Twitter",
      color: "#77BDF1",
      field: MentionType.tweet,
      featureFlag: "view_tweet",
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/twitter.svg`,
      checked: true,
    },
    {
      label: "Facebook Post",
      appLabel: "Facebook",
      color: "#61749D",
      field: MentionType.facebook_post,
      featureFlag: "view_facebook_post",
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/facebook.svg`,
      checked: true,
    },
    {
      label: "Instagram Post",
      appLabel: "Instagram",
      color: "#E3787C",
      field: MentionType.instagram_post,
      featureFlag: "view_instagram_post",
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/instagram.svg`,
      checked: true,
    },
    {
      label: "Instagram Comment",
      appLabel: "Instagram Comments",
      color: "#E3787C",
      field: MentionType.instagram_comment,
      featureFlag: "view_instagram_post",
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/instagram.svg`,
      checked: true,
      hidden: true,
    },
    {
      label: "YouTube Video",
      appLabel: "Youtube",
      color: "#D54B3F",
      field: MentionType.youtube_video,
      featureFlag: "view_youtube_video",
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/youtube.svg`,
      checked: true,
    },
    {
      label: "Reddit Post",
      appLabel: "Reddit Posts",
      color: "#FB7A4A",
      field: MentionType.reddit_post,
      featureFlag: "view_reddit_post",
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/reddit.svg`,
      checked: true,
      hidden: true,
    },
    {
      label: "Reddit Post Comment",
      appLabel: "Reddit Comments",
      color: "#FB7A4A",
      field: MentionType.reddit_post_comment,
      featureFlag: "view_reddit_post",
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/reddit.svg`,
      checked: true,
      hidden: true,
    },
    {
      label: "Blog Post",
      appLabel: "Blog Posts",
      color: "#F06A35",
      field: MentionType.blog_post,
      featureFlag: "view_blog_post",
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/blog.svg`,
      checked: true,
      hidden: true,
    },
    {
      label: "Forum Post",
      appLabel: "Forum Posts",
      color: "#FFB649",
      field: MentionType.forum_post,
      featureFlag: "view_forum_post",
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/forum.svg`,
      checked: true,
      hidden: true,
    },
    {
      label: "Bluesky Post",
      appLabel: "Bluesky Posts",
      color: "#1285FE",
      field: MentionType.bluesky_post,
      featureFlag: "view_bluesky_post",
      icon: `${import.meta.env.VITE_ASSETS_URL}/icons/bluesky.svg`,
      checked: true,
      hidden: true,
    },
  ],
  relatedCamelCaseFields: [
    "Tweet",
    "FacebookPost",
    "YoutubeVideo",
    "InstagramPost",
    "InstagramComment",
    "RedditPost",
    "RedditPostComment",
    "BlogPost",
    "ForumPost",
    "BlueskyPost",
  ],
  sourceLabel: "Source",
  featureFlag: "has_social_platform",
  displayExcerptsFeature: "has_social_platform",
  triggerAlert: false,
  hasNotification: true,
  filterEnabled: true,
  categoryLocationFiltersEnabled: true,
};
